import { useQuery } from "@tanstack/react-query"
import { projectsApi } from "../api/projects"

// Query keys
export const projectMetaKeys = {
  all: ["projectMeta"] as const,
}

// Hook to fetch project metadata
export const useProjectMeta = () => {
  return useQuery({
    queryKey: projectMetaKeys.all,
    queryFn: projectsApi.getProjectMeta,
  })
}
